import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { EMPTY_ITEM_RIGHTS_COLLECTION } from "../../../../Global/Base/Rights/RightTypes";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { Edit } from "../../../UI.BaseControls/Edit";
import { IAction } from "../../../UI.Controls/Actions/IAction";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ContainerToolbarControl, ToolbarControl } from "./ToolbarControl";

const logger = LazyLoadingSectionLogger.create(LoggingSection.frames);

/**
 * Control pro fulltextové vyhledávání
 */
export class FulltextSearchControl extends ToolbarControl implements ContainerToolbarControl {
    private readonly _input: Edit;
    private readonly _searchButton: HTMLButtonElement;
    private _searchAction: IAction;
    private _searchFunction: () => void;
    private _clearButton: HTMLButtonElement;
    private _clearButtonHandler: () => void;

    private _oldNotEmpty = false;

    constructor() {
        super({
            element: createElement({ type: "div", classes: "fulltext-search" }),
            originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION,
        });

        this._input = new Edit();
        Localization.addLocTxtData(this._input, "GUI-651767", "placeholder"); // Hledat
        this._input.classList.add("fulltext-input");
        this._input.addEventListener("input", (e: Event) => {
            const value = (e.target as HTMLInputElement).value;
            this._updateClearButtonState(value);
        }, true);
        this.element.appendChild(this._input);

        this._searchButton = createElement({ type: "button", classes: ["fulltext-search-button", "btn", "flat", "icon", "ui-search", "no-caption"] }) as HTMLButtonElement;
        Localization.addLocDescData(this._searchButton, "GUI-651767", "title"); // Hledat
        this.element.appendChild(this._searchButton);

        this._input.addEventListener("keypress", async (eventArgs) => {
            if ((eventArgs as KeyboardEvent).keyCode === 13) { // === Enter
                if (this._searchFunction)
                    await this._searchFunction();
            }
        });
    }

    private _updateClearButtonState(value: string | null): void {
        if (value != null) {
            const notEmpty = value !== "";
            this._input.classList.toggle("not-empty", notEmpty);

            if (notEmpty !== this._oldNotEmpty) {
                if (notEmpty) {
                    this._clearButton = createElement({ type: "button", classes: ["btn", "flat", "clear-button", "icon", "ui-cross-small"] }) as HTMLButtonElement;
                    this._input.appendChild(this._clearButton);
                    this._clearButton.addEventListener("click", this._clearButtonHandler = () => {
                        if (this._clearButton.classList.contains("Disabled"))
                            return;
                        this._clearSearch();
                    });
                } else {
                    if (this._clearButton) {
                        this._clearButton.removeEventListener("click", this._clearButtonHandler);
                        this._clearButton.remove();
                    }
                }
            }
            this._oldNotEmpty = notEmpty;
        }
    }

    private _clearSearch(): void {
        this._input.value = "";
        this._updateClearButtonState("");
        this._input.focus();
        this._searchFunction();
    }

    public addAction(action: IAction): void {
        if (this._searchAction) {
            this._searchButton.removeEventListener("click", this._searchFunction);
        }
        this._searchAction = action;
        this._searchButton.addEventListener("click", this._searchFunction = async () => {
            if (this._searchButton.classList.contains("Disabled"))
                return;
            await this._searchAction.action(this._input.value);
        });
    }

    public removeAction(_action: IAction): void {
        logger.warn("Action cannot be removed. Only replaced.");
    }
}
